module.exports = __webpack_public_path__ + "static/assets/f9774e41ff437d6374a0181d85918506.svg";